/**
 * Determines the number of drivers required for a vanity trip based on the initial states and trip type.
 * @param {Object} initialStates - The initial state object containing delivery items.
 * @param {number} tripType - The type of trip, represented as a number.
 */
export const showNumberOfDrivers = (initialStates, tripType) => {
    const palletWhichHasVanity = initialStates.ItemsToDeliver.filter(data => data.isVanity);
    const noOfDrivers = (tripType === 1 || (tripType % 2 !== 0 && palletWhichHasVanity.length === tripType)) ? tripType + 1 : tripType;
    return `Large item(s) - ${noOfDrivers} drivers`
};
